import React from 'react';
import { Button as ChakraButton, ButtonProps as ChakraButtonProps } from '@chakra-ui/react';

import { darkenColor } from '../../lib';

interface IButtonProps extends ChakraButtonProps {
	backgroundColor?: string;
	hoverDarken?: number; // Percentage to darken color on hover
	activeDarken?: number; // Percentage to darken color when active
}

export const Button: React.FunctionComponent<IButtonProps> = ({
	onClick,
	children,
	backgroundColor = 'blue.500',
	hoverDarken = 15,
	activeDarken = 30,
	...props
}) => {
	return (
		<ChakraButton
			onClick={onClick}
			backgroundColor={backgroundColor}
			_hover={{
				backgroundColor: darkenColor(backgroundColor, hoverDarken),
			}}
			_active={{
				backgroundColor: darkenColor(backgroundColor, activeDarken),
			}}
			_focus={{
				backgroundColor: darkenColor(backgroundColor, activeDarken),
			}}
			boxShadow='none'
			{...props}
		>
			{children}
		</ChakraButton>
	);
};
